import type { AccountEngagement } from '@/types'

/** "3 emails in 6 months, no replies" */
export function emailOnlyText(e: AccountEngagement): string {
  const total = e.emails_out + e.emails_in
  const months = Math.round(e.window_days / 30)
  const emails = `${total} email${total === 1 ? '' : 's'} in ${months} months`
  const replies =
    e.emails_in === 0
      ? 'no replies'
      : `${e.emails_in} repl${e.emails_in === 1 ? 'y' : 'ies'} from the customer`
  return `${emails}, ${replies}. No calls, meetings or completed tasks.`
}
